"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _index = require("./config/index");

var _getRoutineList = _interopRequireDefault(require("./utils/getRoutineList"));

var _index2 = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultSelectedPopoverProps = {
  submitLabel: '确定',
  cancelLabel: '取消',
  cancelButton: true,
  submitButton: true,
  title: '',
  content: _react["default"].createElement(_react["default"].Fragment, null),
  width: '280px',
  bodyHeight: '120px',
  titleHeight: 0
};
/**
 * @class
 */

var TimeRoutineSelector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TimeRoutineSelector, _PureComponent);

  /**
   * 属性说明
   * @alias TimeRoutineSelectorProps
   * @description 时间规律(按周)选择组件
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {string} value='' 时间（二进制）
   * @property {func} onChange 已选时间的二进制字符串变更回调<br />onChange = (value, valueLabel)
   * @property {bool} [disabled=false] 是否禁用
   * @property {object} [locale={}] 替换文案
   * @example
   * locale = {
          Monday: '星期一',
          Tuesday: '星期二',
          Wednesday: '星期三',
          Thursday: '星期四',
          Friday: '星期五',
          Saturday: '星期六',
          Sunday: '星期日',
          week: '星期',
          time: '时间',
          unselected: '未选',
          selected: '已选',
          operationTip: '可拖动鼠标选择时间段',
          empty: '清空',
      };
   */

  /**
   * @private
   */
  function TimeRoutineSelector(props) {
    var _this;

    _classCallCheck(this, TimeRoutineSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeRoutineSelector).call(this, props));
    _this.isMouseDown = false;
    _this.startId = null;
    _this.endId = null;
    _this.targetStatus = _index.SELECT_STATUS.SELECTED;
    _this.originRoutineList = {};
    _this.state = {
      routineList: _this.getRoutineList(props),
      curTip: '',
      tipPos: {
        top: 0,
        left: 0
      },
      selectedPopoverProps: {
        top: 0,
        left: 0
      },
      showSelectedPopover: false,
      activeSelectedValues: []
    };
    _this.hanldeMouseDown = _this.hanldeMouseDown.bind(_assertThisInitialized(_this));
    _this.hanldeMouseMove = _this.hanldeMouseMove.bind(_assertThisInitialized(_this));
    _this.hanldeMouseUp = _this.hanldeMouseUp.bind(_assertThisInitialized(_this));
    _this.hanldeMouseOver = _this.hanldeMouseOver.bind(_assertThisInitialized(_this));
    _this.hanldeMouseLeave = _this.hanldeMouseLeave.bind(_assertThisInitialized(_this));
    _this.updateSelection = _this.updateSelection.bind(_assertThisInitialized(_this));
    _this.endSelection = _this.endSelection.bind(_assertThisInitialized(_this));
    _this.updateSelectedTimeAndDigit = _this.updateSelectedTimeAndDigit.bind(_assertThisInitialized(_this));
    _this.updateTip = _this.updateTip.bind(_assertThisInitialized(_this));
    _this.clearSelect = _this.clearSelect.bind(_assertThisInitialized(_this));
    _this.handleSelectedPopover = _this.handleSelectedPopover.bind(_assertThisInitialized(_this));
    _this.genPopPosition = _this.genPopPosition.bind(_assertThisInitialized(_this));
    _this.handleSelectedPopoverSubmitClick = _this.handleSelectedPopoverSubmitClick.bind(_assertThisInitialized(_this));
    _this.handleSelectedPopoverCancelClick = _this.handleSelectedPopoverCancelClick.bind(_assertThisInitialized(_this));
    _this.handleSelectedPopoverCloseClick = _this.handleSelectedPopoverCloseClick.bind(_assertThisInitialized(_this));
    _this.resetRoutineList = _this.resetRoutineList.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 调用渲染函数，并更新初始选中的时间和二进制字符串
   * @private
   */


  _createClass(TimeRoutineSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 渲染初始化后的选中时间和二进制
      this.updateSelectedTimeAndDigit(true);

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.value !== 'undefined') {
        this.setState({
          routineList: this.getRoutineList(nextProps)
        });
      }
    }
  }, {
    key: "getRoutineList",
    value: function getRoutineList() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = (0, _getRoutineList["default"])(props.value);
      this.routineKeys = result.routineKeys;
      return result.routineList;
    }
    /**
     * 点下鼠标，开始选择动作，必须在选区内部开始
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseDown",
    value: function hanldeMouseDown(event) {
      var _this2 = this;

      var curId = event.target && event.target.getAttribute('data-id');
      var _this$state = this.state,
          routineList = _this$state.routineList,
          showSelectedPopover = _this$state.showSelectedPopover;
      var _this$props = this.props,
          disabled = _this$props.disabled,
          enableSelectedPopover = _this$props.enableSelectedPopover,
          onMouseDown = _this$props.onMouseDown; // // // 如果支持浮层框，点击已选择区域
      // if (routineList[curId] && enableSelectedPopover) {
      //   return;
      // }
      // 弹框打开时，不触发移动

      if (enableSelectedPopover && showSelectedPopover) {
        return;
      }

      if (curId && !disabled) {
        // 支持浮层框时，需要记录每次移动经过的所有值
        if (enableSelectedPopover) {
          this.setState({
            activeSelectedValues: [curId]
          });
        }

        this.originRoutineList = (0, _spauiUtils.objectAssign)({}, routineList);
        this.isMouseDown = true;
        this.startId = curId;
        this.endId = curId;
        this.targetStatus = _index.SELECT_STATUS.SELECTED - this.originRoutineList[curId];

        if (onMouseDown && typeof onMouseDown === 'function') {
          onMouseDown(function (selectedKeys) {
            _this2.resetRoutineList(selectedKeys, true);
          });
        }
      }
    }
    /**
     * 鼠标移动，因移动过程中多次渲染，我们只拿mouseDown时的初始克隆的state做渲染运算
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseMove",
    value: function hanldeMouseMove(event) {
      var _this3 = this;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          enableSelectedPopover = _this$props2.enableSelectedPopover;

      if (this.isMouseDown === true && !disabled) {
        var curId = event.target && event.target.getAttribute('data-id');

        if (curId && curId !== this.endId) {
          this.endId = curId;
          this.updateSelection(this.startId, this.endId, function (newActiveSelectedValues) {
            if (enableSelectedPopover) {
              _this3.setState({
                activeSelectedValues: newActiveSelectedValues.map(function (it) {
                  return String(it);
                })
              });
            }
          });
        }
      }
    }
    /**
     * 松开鼠标
     * @private
     */

  }, {
    key: "hanldeMouseUp",
    value: function hanldeMouseUp(event) {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          enableSelectedPopover = _this$props3.enableSelectedPopover;

      if (this.isMouseDown === true && !disabled) {
        this.endSelection();

        if (enableSelectedPopover) {
          if (this.targetStatus === _index.SELECT_STATUS.SELECTED) {
            this.handleSelectedPopover(event);
          }
        }
      }
    }
    /**
     * 鼠标over时间格子
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "hanldeMouseOver",
    value: function hanldeMouseOver(event) {
      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          disabledText = _this$props4.disabledText; // event.persist(); // 有debounce才需要
      //

      var showSelectedPopover = this.state.showSelectedPopover;

      if (!disabled && !showSelectedPopover) {
        this.updateTip(event);
      } else if (disabled && disabledText) {
        this.updateTip(event, disabledText);
      }
    }
    /**
     * 离开选区
     * tip显示时，内部移动到tip也算hanldeMouseLeave，快速移动可能触发
     * @private
     */

  }, {
    key: "hanldeMouseLeave",
    value: function hanldeMouseLeave() {
      var disabled = this.props.disabled;
      var curTip = this.state.curTip;

      if (!disabled) {
        if (this.isMouseDown === true) {
          this.endSelection();
        }

        if (curTip) {
          this.setState({
            curTip: ''
          });
        }
      }
    }
    /**
     * 处理选择后浮层弹框
     * @private
     */

  }, {
    key: "handleSelectedPopover",
    value: function handleSelectedPopover(event) {
      var _this$props$selectedP = this.props.selectedPopoverProps,
          selectedPopoverProps = _this$props$selectedP === void 0 ? defaultSelectedPopoverProps : _this$props$selectedP;
      var eventOffsetLeft = event.target.offsetLeft;
      var eventOffsetTop = event.target.offsetTop;
      var curId = event.target && event.target.getAttribute('data-id');
      var divideWeekKey = 3;
      var divedeTime = 1300;
      var offsetLeft = eventOffsetLeft + 140;
      var offsetTop = eventOffsetTop + 95;
      var containerWidth = selectedPopoverProps.width || defaultSelectedPopoverProps.width;
      var buffWidth = (parseInt(containerWidth, 10) / _index.boxSize.width).toFixed(1) - 0.5;
      var containerTitleHeight = parseInt(selectedPopoverProps.titleHeight, 10) || parseInt(defaultSelectedPopoverProps.titleHeight, 10);
      var containerBodyHeight = parseInt(selectedPopoverProps.bodyHeight, 10) || parseInt(defaultSelectedPopoverProps.bodyHeight, 10);
      var containerHeight = containerTitleHeight + containerBodyHeight + 77;

      var buffHeight = (containerHeight / _index.boxSize.height).toFixed(1);

      if (curId) {
        var _this$genPopPosition = this.genPopPosition(curId, {
          divideWeekKey: divideWeekKey,
          divedeTime: divedeTime
        }, {
          offsetLeft: offsetLeft,
          offsetTop: offsetTop,
          buffWidth: buffWidth,
          buffHeight: buffHeight
        }),
            left = _this$genPopPosition.left,
            top = _this$genPopPosition.top;

        this.setState({
          selectedPopoverProps: {
            left: left,
            top: top
          },
          showSelectedPopover: true
        }, function () {
          if (selectedPopoverProps.initialFuc && typeof selectedPopoverProps.initialFuc === 'function') {
            selectedPopoverProps.initialFuc();
          }
        });
      }
    }
    /**
     * 处理选择后浮层弹框取消按钮点击事件
     * @private
     */

  }, {
    key: "handleSelectedPopoverCancelClick",
    value: function handleSelectedPopoverCancelClick() {
      var _this$props$selectedP2 = this.props.selectedPopoverProps,
          selectedPopoverProps = _this$props$selectedP2 === void 0 ? defaultSelectedPopoverProps : _this$props$selectedP2;
      var onCancel = selectedPopoverProps.onCancel,
          supportCancelHidePop = selectedPopoverProps.supportCancelHidePop;

      if (supportCancelHidePop) {
        this.setState({
          showSelectedPopover: false
        });
      }

      if (onCancel && typeof onCancel === 'function') {
        onCancel();
      }
    }
    /**
     * 处理选择后浮层弹框确定按钮点击事件
     * @private
     */

  }, {
    key: "handleSelectedPopoverSubmitClick",
    value: function handleSelectedPopoverSubmitClick() {
      var _this$props$selectedP3 = this.props.selectedPopoverProps,
          selectedPopoverProps = _this$props$selectedP3 === void 0 ? defaultSelectedPopoverProps : _this$props$selectedP3;
      var onSubmit = selectedPopoverProps.onSubmit,
          supportSubmitHidePop = selectedPopoverProps.supportSubmitHidePop,
          beforeSubmitCheck = selectedPopoverProps.beforeSubmitCheck;
      var submitOk = true;

      if (beforeSubmitCheck && typeof beforeSubmitCheck === 'function') {
        var isCheckOk = beforeSubmitCheck();

        if (!isCheckOk) {
          submitOk = false;
        }
      }

      if (submitOk) {
        if (supportSubmitHidePop) {
          this.setState({
            showSelectedPopover: false
          });
        }

        if (onSubmit && typeof onSubmit === 'function') {
          onSubmit();
        }
      }
    }
  }, {
    key: "resetRoutineList",
    value: function resetRoutineList(keys, canRestOriginRoutineList) {
      var stateRoutineList = this.state.routineList;
      var routineList = (0, _spauiUtils.objectAssign)({}, stateRoutineList);
      this.routineKeys.forEach(function (item) {
        if (keys.includes(item)) {
          routineList[item] = _index.SELECT_STATUS.SELECTED;
        } else {
          routineList[item] = _index.SELECT_STATUS.UNSELECTED;
        }
      });
      this.setState({
        routineList: routineList
      });

      if (canRestOriginRoutineList) {
        this.originRoutineList = (0, _spauiUtils.objectAssign)({}, routineList);
      }
    }
  }, {
    key: "handleSelectedPopoverCloseClick",

    /**
     * 处理选择后浮层弹框关闭按钮点击事件
     */
    value: function handleSelectedPopoverCloseClick() {
      var _this4 = this;

      var _this$props5 = this.props,
          enableSelectedPopover = _this$props5.enableSelectedPopover,
          _this$props5$selected = _this$props5.selectedPopoverProps,
          selectedPopoverProps = _this$props5$selected === void 0 ? defaultSelectedPopoverProps : _this$props5$selected;
      var showSelectedPopover = this.state.showSelectedPopover;
      var onPopClose = selectedPopoverProps.onPopClose; // 如果浮层框在打开状态，隐藏浮层

      if (enableSelectedPopover && showSelectedPopover) {
        this.setState({
          activeSelectedValues: [],
          showSelectedPopover: false
        }, function () {
          if (onPopClose && typeof onPopClose === 'function') {
            onPopClose(function (newKeys) {
              _this4.resetRoutineList(newKeys);
            });
          }
        });
      }
    }
    /**
     * 结束选择动作
     * @private
     */

  }, {
    key: "endSelection",
    value: function endSelection() {
      var _this5 = this;

      this.updateSelection(this.startId, this.endId, function () {
        _this5.updateSelectedTimeAndDigit(); // 中间过程使用state，结束之后还是要把选中的数据重新重置用value的值显示


        _this5.setState({
          routineList: _this5.getRoutineList(_this5.props)
        });
      });
      this.originRoutineList = {};
      this.startId = null;
      this.endId = null;
      this.isMouseDown = false;
    }
    /**
     * 更新当前选择的时间界面
     * @param {string} startId - 起始时间id
     * @param {string} endId - 结束时间id
     * @param {func} cb - 更新完state后的回调函数
     * @return {void}
     * @private
     */

  }, {
    key: "updateSelection",
    value: function updateSelection(startId, endId, cb) {
      var _this6 = this;

      if (startId && endId) {
        var week = [startId.slice(0, 1) - 0, endId.slice(0, 1) - 0].sort(function (a, b) {
          return a - b;
        }); // 星期起止

        var time = [startId.slice(1) - 0, endId.slice(1) - 0].sort(function (a, b) {
          return a - b;
        }); // 时间起止
        // 得到需要改值的key的数组

        var selectedList = [];

        for (var i = week[0]; i <= week[1]; i++) {
          for (var j = time[0]; j <= time[1]; j += 50) {
            selectedList.push(i * 10000 + j);
          }
        }

        var routineList = (0, _spauiUtils.objectAssign)({}, this.originRoutineList);
        selectedList.forEach(function (item) {
          if (routineList[item] !== _this6.targetStatus) {
            routineList[item] = _this6.targetStatus;
          }
        });
        this.setState({
          routineList: routineList
        }, function () {
          if (cb) {
            cb(selectedList);
          }
        });
      }
    }
    /**
     * 根据当前routineList状态得到选择时间段字符串数组、二进制字符串
     * @param {bool} notCallOnChange=false 是否调用onChange函数
     * @private
     */

  }, {
    key: "updateSelectedTimeAndDigit",
    value: function updateSelectedTimeAndDigit() {
      var notCallOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$state2 = this.state,
          routineList = _this$state2.routineList,
          activeSelectedValues = _this$state2.activeSelectedValues;
      var _this$props6 = this.props,
          onChange = _this$props6.onChange,
          enableSelectedPopover = _this$props6.enableSelectedPopover;
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE);

      var _genTimeRoutine = (0, _index2.genTimeRoutine)(this.routineKeys, routineList, weekDayNames),
          _genTimeRoutine2 = _slicedToArray(_genTimeRoutine, 2),
          digitsStr = _genTimeRoutine2[0],
          showArr = _genTimeRoutine2[1];

      var activeRoutineList = this.routineKeys.reduce(function (target, val) {
        var res = target;
        res[val] = activeSelectedValues.includes(val) ? _index.SELECT_STATUS.SELECTED : _index.SELECT_STATUS.UNSELECTED;
        return target;
      }, {});

      var _genTimeRoutine3 = (0, _index2.genTimeRoutine)(this.routineKeys, activeRoutineList, weekDayNames),
          _genTimeRoutine4 = _slicedToArray(_genTimeRoutine3, 2),
          activeValueStr = _genTimeRoutine4[0],
          showActiveArr = _genTimeRoutine4[1];

      if ((0, _spauiUtils.isFunction)(onChange) && !notCallOnChange) {
        if (enableSelectedPopover) {
          onChange(digitsStr, showArr, activeValueStr, showActiveArr, activeSelectedValues, this.targetStatus);
        } else {
          onChange(digitsStr, showArr);
        }
      }
    }
    /**
     * 获取当前浮层浮动位置公共方法
     * @private
     */

  }, {
    key: "genPopPosition",
    value: function genPopPosition(curId, _ref, _ref2) {
      var divideWeekKey = _ref.divideWeekKey,
          divedeTime = _ref.divedeTime;
      var offsetLeft = _ref2.offsetLeft,
          offsetTop = _ref2.offsetTop,
          buffWidth = _ref2.buffWidth,
          buffHeight = _ref2.buffHeight;
      var weekKey = curId.slice(0, 1) - 1;
      var time = curId.slice(1) - 0;
      var left;
      var top; // 确定tip显示位置(右下/左下/右上/左上)

      if (weekKey <= divideWeekKey && time <= divedeTime) {
        left = offsetLeft + _index.boxSize.width;
        top = offsetTop + _index.boxSize.height;
      } else if (weekKey <= divideWeekKey && time > divedeTime) {
        left = offsetLeft - buffWidth * _index.boxSize.width;
        top = offsetTop + _index.boxSize.height;
      } else if (weekKey > divideWeekKey && time <= divedeTime) {
        left = offsetLeft + _index.boxSize.width;
        top = offsetTop - buffHeight * _index.boxSize.height;
      } else {
        left = offsetLeft - buffWidth * _index.boxSize.width;
        top = offsetTop - buffHeight * _index.boxSize.height;
      }

      return {
        left: left,
        top: top
      };
    }
    /**
     * 更新tip内容，确定tip显示位置
     * @param {object} event - 事件event对象
     * @return {void}
     * @private
     */

  }, {
    key: "updateTip",
    value: function updateTip(event, text) {
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE);
      var curId = event.target.getAttribute('data-id');
      var offsetLeft = event.target.offsetLeft;
      var offsetTop = event.target.offsetTop;
      var divideWeekKey = 5;
      var divedeTime = 1800;

      if (curId) {
        var weekKey = curId.slice(0, 1) - 1;
        var time = curId.slice(1) - 0;
        var startTime = (0, _index2.timeTranslate)((10000 + time - 50).toString().slice(-4));
        var endTime = (0, _index2.timeTranslate)((10000 + time).toString().slice(-4));
        var weekShow = weekDayNames[weekKey] ? "".concat(weekDayNames[weekKey], " ") : '';
        var curTip = "".concat(weekShow + startTime, "-").concat(endTime);
        var buffWidth = 12;
        var buffHeight = 1;

        var _this$genPopPosition2 = this.genPopPosition(curId, {
          divideWeekKey: divideWeekKey,
          divedeTime: divedeTime
        }, {
          offsetLeft: offsetLeft,
          offsetTop: offsetTop,
          buffWidth: buffWidth,
          buffHeight: buffHeight
        }),
            left = _this$genPopPosition2.left,
            top = _this$genPopPosition2.top;

        this.setState({
          curTip: text || curTip,
          tipPos: {
            left: left,
            top: top
          }
        });
      }
    }
    /**
     * 清空已选时间
     * @private
     */

  }, {
    key: "clearSelect",
    value: function clearSelect() {
      var _this7 = this;

      var _this$props7 = this.props,
          enableSelectedPopover = _this$props7.enableSelectedPopover,
          onClear = _this$props7.onClear;
      var _this$state3 = this.state,
          stateRoutineList = _this$state3.routineList,
          showSelectedPopover = _this$state3.showSelectedPopover;
      var routineList = (0, _spauiUtils.objectAssign)({}, stateRoutineList);
      this.routineKeys.forEach(function (item) {
        routineList[item] = _index.SELECT_STATUS.UNSELECTED;
      });
      this.setState(_objectSpread({
        routineList: routineList
      }, enableSelectedPopover ? {
        activeSelectedValues: []
      } : {}), function () {
        _this7.updateSelectedTimeAndDigit();

        if (onClear && typeof onClear === 'function') {
          onClear();
        }
      }); // 如果浮层框在打开状态，隐藏浮层

      if (showSelectedPopover) {
        this.setState({
          showSelectedPopover: false
        });
      }
    }
    /**
     * 临时占位模版
     * @private
     * @return {Object} 返回模版
     */

  }, {
    key: "getTempTemplate",
    value: function getTempTemplate() {
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {}, TimeRoutineSelector, this.props));
    }
  }, {
    key: "render",
    value: function render() {
      var LOCALE = (0, _index.getLocaleData)(this.props.locale);
      var weekDayNames = (0, _index.getWeekDayNames)(LOCALE);
      var _this$props8 = this.props,
          disabled = _this$props8.disabled,
          _this$props8$selected = _this$props8.selectedPopoverProps,
          selectedPopoverProps = _this$props8$selected === void 0 ? defaultSelectedPopoverProps : _this$props8$selected;
      var _this$state4 = this.state,
          curTip = _this$state4.curTip,
          tipPos = _this$state4.tipPos,
          routineList = _this$state4.routineList,
          selectedPopoverState = _this$state4.selectedPopoverProps,
          showSelectedPopover = _this$state4.showSelectedPopover,
          activeSelectedValues = _this$state4.activeSelectedValues;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spa-ui'
      }, TimeRoutineSelector), _react["default"].createElement("div", {
        className: " with-title with-btns spaui-popover fade in",
        style: {
          display: showSelectedPopover ? 'block' : 'none',
          left: selectedPopoverState.left,
          top: selectedPopoverState.top,
          width: selectedPopoverProps.width || defaultSelectedPopoverProps.width
        }
      }, _react["default"].createElement("div", {
        className: "spaui-popover-content"
      }, _react["default"].createElement("div", {
        style: {
          height: 20
        }
      }, selectedPopoverProps.showCloseButton && _react["default"].createElement("button", {
        type: "button",
        className: "close",
        style: {
          "float": 'right',
          cursor: 'pointer'
        },
        onClick: this.handleSelectedPopoverCloseClick
      }, _react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), _react["default"].createElement("h1", {
        className: "spaui-popover-title"
      }, selectedPopoverProps.title || defaultSelectedPopoverProps.title)), _react["default"].createElement("div", {
        className: "spaui-popover-body",
        style: {
          height: selectedPopoverProps.bodyHeight || defaultSelectedPopoverProps.bodyHeight
        }
      }, selectedPopoverProps.content || defaultSelectedPopoverProps.content), _react["default"].createElement("div", {
        className: "spaui-popover-btns",
        style: {
          width: selectedPopoverProps.width || defaultSelectedPopoverProps.width,
          padding: '10px 20px 0'
        }
      }, (selectedPopoverProps.cancelButton === undefined || selectedPopoverProps.cancelButton === true) && _react["default"].createElement("button", {
        className: "btn btn-default",
        onClick: this.handleSelectedPopoverCancelClick
      }, selectedPopoverProps.cancelLabel || defaultSelectedPopoverProps.cancelLabel), (selectedPopoverProps.submitButton === undefined || selectedPopoverProps.submitButton === true) && _react["default"].createElement("button", {
        className: "btn btn-primary",
        onClick: this.handleSelectedPopoverSubmitClick
      }, selectedPopoverProps.submitLabel || defaultSelectedPopoverProps.submitLabel)))), _react["default"].createElement("div", {
        className: "duration"
      }, _react["default"].createElement("ul", {
        className: "header"
      }, _react["default"].createElement("li", {
        className: "pull-left info"
      }, ' ', LOCALE.week, '\\', LOCALE.time, ' '), _react["default"].createElement("li", {
        className: "pull-left time"
      }, _react["default"].createElement("div", {
        className: "num"
      }, "00:00 - 12:00"), _react["default"].createElement("ul", {
        className: "detail clearfix"
      }, _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "0"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "1"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "2"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "3"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "4"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "5"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "6"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "7"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "8"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "9"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "10"), _react["default"].createElement("li", {
        className: "digital pull-left last"
      }, "11"))), _react["default"].createElement("li", {
        className: "pull-left time"
      }, _react["default"].createElement("div", {
        className: "num"
      }, "12:00 - 24:00"), _react["default"].createElement("ul", {
        className: "detail clearfix"
      }, _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "12"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "13"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "14"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "15"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "16"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "17"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "18"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "19"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "20"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "21"), _react["default"].createElement("li", {
        className: "digital pull-left"
      }, "22"), _react["default"].createElement("li", {
        className: "digital pull-left last"
      }, "23")))), _react["default"].createElement("div", {
        className: "content"
      }, this.isMouseDown === false && curTip ? _react["default"].createElement("div", {
        className: "timetip",
        style: tipPos
      }, _react["default"].createElement("p", null, curTip)) : '', _react["default"].createElement("ul", {
        className: "pull-left week"
      }, weekDayNames.map(function (item, key) {
        return _react["default"].createElement("li", {
          className: "day",
          key: "week_".concat(key)
        }, item);
      })), _react["default"].createElement("ul", {
        className: "boxzone",
        onMouseDown: this.hanldeMouseDown,
        onMouseMove: this.hanldeMouseMove,
        onMouseUp: this.hanldeMouseUp,
        onMouseOver: this.hanldeMouseOver,
        onMouseLeave: this.hanldeMouseLeave
      }, this.routineKeys.map(function (item) {
        return _react["default"].createElement("li", {
          className: "box ".concat(routineList[item] === _index.SELECT_STATUS.SELECTED && !activeSelectedValues.includes(item) ? 'active' : '', " ").concat(routineList[item] === _index.SELECT_STATUS.SELECTED && activeSelectedValues.includes(item) ? 'highlight' : ''),
          "data-id": item,
          key: item
        });
      })))), _react["default"].createElement("div", {
        className: "duration-tipline"
      }, _react["default"].createElement("span", {
        className: "color-box color-blue"
      }), _react["default"].createElement("span", null, LOCALE.selected), _react["default"].createElement("span", {
        className: "color-box"
      }), _react["default"].createElement("span", null, LOCALE.unselected), _react["default"].createElement("span", {
        className: "weektip"
      }, LOCALE.operationTip), disabled ? null : _react["default"].createElement("a", {
        style: {
          cursor: 'pointer'
        },
        className: "emptied",
        onClick: this.clearSelect
      }, LOCALE.empty)));
    }
  }]);

  return TimeRoutineSelector;
}(_react.PureComponent); // 组件标记


_defineProperty(TimeRoutineSelector, "propTypes", {
  value: _spauiUtils.PropTypes.string.isRequired,
  disabled: _spauiUtils.PropTypes.bool,
  onChange: _spauiUtils.PropTypes.func.isRequired,
  locale: _spauiUtils.PropTypes.object
});

_defineProperty(TimeRoutineSelector, "defaultProps", {
  value: '',
  disabled: false,
  locale: {},
  disabledText: '',
  enableSelectedPopover: false,
  selectedPopoverProps: {}
});

(0, _spauiUtils.setComponentMark)(TimeRoutineSelector, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = TimeRoutineSelector;
exports["default"] = _default;